module.exports = __webpack_public_path__ + "static/media/coupon-close.bb31cc60.svg";